<div class="flex items-center justify-center gap-2 ml-2 select-none">
    <div>
        <h3 class="text-primary font-bold">{{ "service_worker.new_version_available" | translate }}</h3>
    </div>

    <div>
        <button mat-button (click)="updateApp()">
            {{ "service_worker.update" | translate }}
        </button>
    </div>
</div>
